import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { PeriodoDashboard } from "@base/contracts";
import { useDashboardGateway } from "./dashboard.contexto";

import { useAuth } from "../../../shared/auth/auth.contexto";

export function useResumoDashboard(opcoes: {
  readonly periodo: PeriodoDashboard;
  readonly mes?: string;
}) {
  const gateway = useDashboardGateway();
  return useQuery({
    queryKey: ["dashboard", "resumo", opcoes.periodo, opcoes.mes ?? ""],
    queryFn: () =>
      gateway.obterResumo({
        periodo: opcoes.periodo,
        ...(opcoes.mes ? { mes: opcoes.mes } : {}),
      }),
  });
}

export function useColetarMetricasDashboard() {
  const gateway = useDashboardGateway();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => gateway.coletarMetricas(),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["dashboard"] });
    },
  });
}

export function useTemDashboard(): boolean {
  const { sessao } = useAuth();
  return sessao?.escopos.includes("dashboard:ler") ?? false;
}

export function useTemDashboardGerir(): boolean {
  const { sessao } = useAuth();
  return sessao?.escopos.includes("dashboard:gerir") ?? false;
}
